export class MessageForm {
  messageId: number;
  senderId: number;
  orgId: number;
  orgLevel: number;
  sentDate: Date;
  status: string;
  tags: string;
  message: string;
  shareall: string;
  memberid: string;
  firstname: string;
  lastname: string;
  patientFirstName: string;
  patientLastName: string;
  receiverIds: string;
  receiverNames: string;
  docid: string;
  attachment: string;
  groupmessage: boolean;
  videochatrequest: boolean;
  recipients: string;
  subject: string;
  otherSubject: string;
  displaySubject: string;
  parentId: number;
  recipientsNames: string;
  displayId: string;
  referralId: string;
}

export enum MessageStatus {
  SENT = 'SENT',
  RECEIVED = 'RECEIVED',
  REPLIED = 'REPLIED',
  OPEN = 'OPEN',
  UNREAD = 'UNREAD',
  READ = 'READ'
}

export class SendMessage {
  patientId: string;
  recipientUserIds: string[];
  message: string;
  tags: string;
  subject: string = null;
  otherSubject: string;
  referralId: string;
}

export interface MessageSearch {
  senderName: string;
  patientName: string;
  receiverName: string;
  message: string;
  tag: string;
  subject: string;
  otherSubject: string;
}

export interface DisplayValue {
  value: string;
  display: string;
}
